import { ChangeDetectionStrategy, Component } from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";
import { PATRONS_LINKS, SocialLinks } from "../where-you-can-fly.component";

@UntilDestroy()
@Component({
    selector: "dtm-main-page-lib-campaign-patrons",
    templateUrl: "./campaign-patrons.component.html",
    styleUrls: ["./campaign-patrons.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampaignPatronsComponent {
    protected PATRON_LINKS = PATRONS_LINKS;

    protected assumeSocialLinksType(obj: unknown): SocialLinks {
        return obj as SocialLinks;
    }
}
